// extracted by mini-css-extract-plugin
module.exports = {"content":"AdditionalNav_content__XMOeb","button":"AdditionalNav_button__gM9_J"};